"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Bosnian localization
 */
exports.default = {
    didNotBackUpWallet: "Ako niste napravili sigurnosnu kopiju svog certifikata ili ste izgubili telefon, kontaktirajte podršku @RelicSupport.",
};
//# sourceMappingURL=bs.js.map